import Consumer from './Consumer';
import Provider from './Provider';

export default {
  Consumer,
  Provider,
};
